import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/pages/Home.vue'
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/pages/Login.vue')
  },
  {
    path: '/miniozet/:id/:page',
    name: 'MiniOzetIDPage',
    component: () => import(/* webpackChunkName: "miniozetidpage" */ '../views/pages/MiniOzet.vue')
  },
  {
    path: '/miniozet/:id',
    name: 'MiniOzetID',
    component: () => import(/* webpackChunkName: "miniozetid" */ '../views/pages/MiniOzet.vue')
  },
  {
    path: '/sifreler/:id/:page',
    name: 'SifrelerIdPage',
    component: () => import(/* webpackChunkName: "SifrelerIdPage" */ '../views/pages/Sifreler.vue')
  },
  {
    path: '/sifreler/:id',
    name: 'SifrelerId',
    component: () => import(/* webpackChunkName: "SifrelerId" */ '../views/pages/Sifreler.vue')
  },
  {
    path: '/videohocalar/:id/:page',
    name: 'VideoHocalarIDPage',
    component: () => import(/* webpackChunkName: "VideoHocalarIDPage" */ '../views/pages/VideoHocalar.vue')
  },
  {
    path: '/videohocalar/:id',
    name: 'VideoHocalarID',
    component: () => import(/* webpackChunkName: "VideoHocalarID" */ '../views/pages/VideoHocalar.vue')
  },
  {
    path: '/videolar/:id/:page',
    name: 'VideolarIDPage',
    component: () => import(/* webpackChunkName: "VideolarIDPage" */ '../views/pages/Videolar.vue')
  },
  {
    path: '/videolar/:id',
    name: 'VideolarID',
    component: () => import(/* webpackChunkName: "VideolarID" */ '../views/pages/Videolar.vue')
  },
  {
    path: '/detay/:id/:page',
    name: 'DetayIdPage',
    component: () => import(/* webpackChunkName: "DetayIdPage" */ '../views/pages/DetayliAnlatim.vue')
  },
  {
    path: '/detay/:id',
    name: 'DetayId',
    component: () => import(/* webpackChunkName: "DetayId" */ '../views/pages/DetayliAnlatim.vue')
  },
  {
    path: '/konutestleri/:id/:page',
    name: 'KonuTestleriIdPage',
    component: () => import(/* webpackChunkName: "KonuTestleriIdPage" */ '../views/pages/KonuTestleri.vue')
  },
  {
    path: '/konutestleri/:id',
    name: 'KonuTestleriId',
    component: () => import(/* webpackChunkName: "KonuTestleriId" */ '../views/pages/KonuTestleri.vue')
  },
  {
    path: '/sinavlar/:ne/:id/:page',
    name: 'SinavlarIdPage',
    component: () => import(/* webpackChunkName: "DetayIdPage" */ '../views/pages/Sinavlar.vue')
  },
  {
    path: '/sinavlar/:ne/:id',
    name: 'SinavlarId',
    component: () => import(/* webpackChunkName: "DetayId" */ '../views/pages/Sinavlar.vue')
  },
  {
    path: '/sorular/:ne/:routeid/:id',
    name: 'SorularId',
    component: () => import(/* webpackChunkName: "SorularId" */ '../views/pages/Sorular.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
